import { useState } from "react";
import { C } from "../components/UI";

export default function Sobre() {
  const [activeTab, setActiveTab] = useState("quem");

  return (
    <div style={{ minHeight: "100vh", background: C.background }}>
      
      {/* Header com abas */}
      <section style={{ 
        background: C.roseMid,
        padding: "60px 20px 0",
        textAlign: "center"
      }}>
        <h1 style={{ 
          fontFamily: "'Playfair Display', serif",
          fontSize: 36,
          fontWeight: 700,
          color: "#fff",
          marginBottom: 32
        }}>
          Sobre a WoMom
        </h1>
        
        {/* Abas */}
        <div style={{ display: "flex", justifyContent: "center", gap: 8, flexWrap: "wrap" }}>
          <button
            onClick={() => setActiveTab("quem")}
            style={{
              padding: "16px 32px",
              fontSize: 16,
              fontWeight: 600,
              background: activeTab === "quem" ? C.background : "transparent",
              color: activeTab === "quem" ? C.roseMid : "#fff",
              border: "none",
              borderRadius: "12px 12px 0 0",
              cursor: "pointer",
              transition: "all 0.2s ease"
            }}
          >
            Quem somos
          </button>
          <button
            onClick={() => setActiveTab("missao")}
            style={{
              padding: "16px 32px",
              fontSize: 16,
              fontWeight: 600,
              background: activeTab === "missao" ? C.background : "transparent",
              color: activeTab === "missao" ? C.roseMid : "#fff",
              border: "none",
              borderRadius: "12px 12px 0 0",
              cursor: "pointer",
              transition: "all 0.2s ease"
            }}
          >
            Missão, Visão e Valores
          </button>
          <button
            onClick={() => setActiveTab("valores")}
            style={{
              padding: "16px 32px",
              fontSize: 16,
              fontWeight: 600,
              background: activeTab === "valores" ? C.background : "transparent",
              color: activeTab === "valores" ? C.roseMid : "#fff",
              border: "none",
              borderRadius: "12px 12px 0 0",
              cursor: "pointer",
              transition: "all 0.2s ease"
            }}
          >
            Valores mais procurados
          </button>
        </div>
      </section>

      {/* Conteúdo das abas */}
      {activeTab === "quem" && (
        <section style={{ maxWidth: 900, margin: "0 auto", padding: "60px 20px" }}>
          <div style={{ 
            background: C.surface,
            borderRadius: 16,
            padding: 32,
            border: `1px solid ${C.border}`,
            marginBottom: 32
          }}>
            <h2 style={{ 
              fontFamily: "'Playfair Display', serif",
              fontSize: 28,
              fontWeight: 700,
              color: C.roseMid,
              marginBottom: 16
            }}>
              Transformando o mercado de trabalho para mulheres
            </h2>
            <p style={{ fontSize: 16, color: C.textMain, lineHeight: 1.8, marginBottom: 16 }}>
              O mercado de trabalho ainda apresenta desafios específicos para mulheres. Muitas vezes faltam informações transparentes sobre cultura, oportunidades e respeito nas empresas.
            </p>
            <p style={{ fontSize: 16, color: C.textMain, lineHeight: 1.8, marginBottom: 16 }}>
              A WoMom nasceu para trazer mais transparência ao mercado de trabalho. Aqui, mulheres podem:
            </p>
            <ul style={{ fontSize: 16, color: C.textMain, lineHeight: 2, paddingLeft: 24 }}>
              <li>Compartilhar experiências reais sobre empresas</li>
              <li>Descobrir ambientes de trabalho mais inclusivos</li>
              <li>Encontrar oportunidades em empresas que valorizam talento feminino</li>
            </ul>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 24 }}>
            {[
              { titulo: "Avaliar empresas", descricao: "Compartilhe sua experiência sobre empresas onde você trabalha e/ou trabalhou e ajude outras mulheres a tomar decisões de carreira mais informadas." },
              { titulo: "Descobrir oportunidades", descricao: "Explore vagas em empresas comprometidas com diversidade e inclusão." },
              { titulo: "Crescer na carreira", descricao: "Acesse conteúdos e recursos sobre carreira, cultura corporativa e desenvolvimento profissional." }
            ].map((item) => (
              <div key={item.titulo} style={{ 
                background: C.surface,
                borderRadius: 16,
                padding: 24,
                border: `1px solid ${C.border}`
              }}>
                <h3 style={{ fontSize: 18, fontWeight: 600, color: C.roseMid, marginBottom: 12 }}>{item.titulo}</h3>
                <p style={{ fontSize: 14, color: C.textSec, lineHeight: 1.6 }}>{item.descricao}</p>
              </div>
            ))}
          </div>
        </section>
      )}

      {activeTab === "missao" && (
        <section style={{ maxWidth: 900, margin: "0 auto", padding: "60px 20px" }}>
          <div style={{ 
            background: C.surface,
            borderRadius: 16,
            padding: 32,
            border: `1px solid ${C.border}`,
            marginBottom: 32
          }}>
            <h2 style={{ 
              fontFamily: "'Playfair Display', serif",
              fontSize: 28,
              fontWeight: 700,
              color: C.roseMid,
              marginBottom: 16
            }}>
              Missão
            </h2>
            <p style={{ fontSize: 16, color: C.textMain, lineHeight: 1.8 }}>
              Promover transparência no mercado de trabalho, permitindo que mulheres compartilhem experiências reais sobre empresas e encontrem oportunidades em ambientes que valorizam diversidade e respeito.
            </p>
          </div>

          <div style={{ 
            background: C.surface,
            borderRadius: 16,
            padding: 32,
            border: `1px solid ${C.border}`,
            marginBottom: 32
          }}>
            <h2 style={{ 
              fontFamily: "'Playfair Display', serif",
              fontSize: 28,
              fontWeight: 700,
              color: C.roseMid,
              marginBottom: 16
            }}>
              Visão
            </h2>
            <p style={{ fontSize: 16, color: C.textMain, lineHeight: 1.8 }}>
              Ser a principal plataforma de referência para mulheres avaliarem empresas e tomarem decisões de carreira mais informadas.
            </p>
          </div>

          <div style={{ 
            background: C.surface,
            borderRadius: 16,
            padding: 32,
            border: `1px solid ${C.border}`
          }}>
            <h2 style={{ 
              fontFamily: "'Playfair Display', serif",
              fontSize: 28,
              fontWeight: 700,
              color: C.roseMid,
              marginBottom: 24
            }}>
              Valores
            </h2>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 24 }}>
              {[
                { titulo: "Empoderamento feminino", descricao: "Acreditamos no poder das mulheres para transformar o mercado de trabalho." },
                { titulo: "Transparência", descricao: "Promovemos avaliações honestas e informações claras." },
                { titulo: "Diversidade e inclusão", descricao: "Valorizamos ambientes de trabalho diversos e respeitosos." },
                { titulo: "Comunidade e colaboração", descricao: "Conectamos mulheres e empresas para construir oportunidades melhores." },
                { titulo: "Impacto positivo", descricao: "Trabalhamos para gerar mudanças reais no mercado de trabalho." },
                { titulo: "Confiança", descricao: "Criamos um espaço seguro para compartilhar experiências." }
              ].map((valor) => (
                <div key={valor.titulo}>
                  <h4 style={{ fontSize: 16, fontWeight: 600, color: C.roseMid, marginBottom: 6 }}>{valor.titulo}</h4>
                  <p style={{ fontSize: 14, color: C.textSec, lineHeight: 1.6 }}>{valor.descricao}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {activeTab === "valores" && (
        <section style={{ maxWidth: 1100, margin: "0 auto", padding: "60px 20px" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 24 }}>
            {[
              { 
                emoji: "💼", 
                titulo: "Carreira", 
                items: [
                  { nome: "Equidade salarial", desc: "Homens e mulheres recebem salários justos para as mesmas funções" },
                  { nome: "Mulheres na liderança", desc: "Presença feminina em cargos de gestão e tomada de decisão" },
                  { nome: "Crescimento", desc: "Oportunidades reais de desenvolvimento e progressão na carreira" }
                ]
              },
              { 
                emoji: "🧠", 
                titulo: "Qualidade de vida", 
                items: [
                  { nome: "Flexibilidade", desc: "Liberdade para equilibrar trabalho e vida pessoal" },
                  { nome: "Trabalho híbrido", desc: "Possibilidade de trabalhar de forma remota e presencial" },
                  { nome: "Bem-estar", desc: "A empresa se preocupa com a saúde física e mental das pessoas" }
                ]
              },
              { 
                emoji: "👩‍👧", 
                titulo: "Apoio", 
                items: [
                  { nome: "Maternidade", desc: "Apoio real para gestantes e mães no ambiente de trabalho" },
                  { nome: "Família", desc: "Respeito ao tempo e às necessidades da vida pessoal" },
                  { nome: "Ambiente saudável", desc: "Clima respeitoso, seguro e livre de discriminação" }
                ]
              }
            ].map((categoria) => (
              <div key={categoria.titulo} style={{ 
                background: C.surface,
                borderRadius: 16,
                padding: 32,
                border: `1px solid ${C.border}`
              }}>
                <div style={{ fontSize: 32, marginBottom: 12 }}>{categoria.emoji}</div>
                <h3 style={{ 
                  fontFamily: "'Playfair Display', serif",
                  fontSize: 22,
                  fontWeight: 700,
                  color: C.roseMid,
                  marginBottom: 16
                }}>
                  {categoria.titulo}
                </h3>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {categoria.items.map((item) => (
                    <li key={item.nome} style={{ 
                      padding: "12px 0",
                      borderBottom: `1px solid ${C.border}`
                    }}>
                      <div style={{ fontSize: 15, fontWeight: 600, color: C.textMain, marginBottom: 4 }}>{item.nome}</div>
                      <div style={{ fontSize: 13, color: C.textSec, lineHeight: 1.5 }}>{item.desc}</div>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
